module.exports = __webpack_public_path__ + "static/media/login.6f67eaf0.png";